// Runtime config for the admin portal. CF Access identity is platform-injected
// (ARCHITECTURE-v2 §2). The admin bearer token is NOT in this config in
// production — the same-origin Pages Function attaches it on the way to the
// Worker. Config is provided via window.__GV_BOOKS_ADMIN__ (operatorId, and
// empty apiBase meaning this origin) or explicitly in tests.

import type { AdminConfig } from "./types.js";

declare global {
  interface Window {
    __GV_BOOKS_ADMIN__?: Partial<AdminConfig>;
  }
}

export function readConfig(overrides: Partial<AdminConfig> = {}): AdminConfig {
  const injected = typeof window !== "undefined" ? window.__GV_BOOKS_ADMIN__ : undefined;
  const apiBase = (overrides.apiBase ?? injected?.apiBase ?? "").replace(/\/+$/, "");
  const token = overrides.token ?? injected?.token ?? "";
  const operatorId = overrides.operatorId ?? injected?.operatorId ?? "";

  if (!operatorId) {
    throw new Error("Admin portal: missing operatorId (resolvedBy)");
  }

  return { apiBase, token, operatorId };
}
